import { get } from 'lodash-es';
import * as Actions from './entities.actions';

const urlMap = [
  /^\/fulfillmentplan\/saveconfigandrate\/[0-9A-Fa-f-]+$/i,
  /^\/fulfillmentplan\/saveconfigandrateexternalfulfillment\/[0-9A-Fa-f-]+$/i,
];

export const ratePatcher = (url = '', responseData, dispatch) => {
  const matchingUrls = urlMap.filter((i) => url.match(i));

  if (matchingUrls.length === 0) {
    return;
  }

  dispatch(Actions.entitiesPatchRates(get(responseData, 'fulfillmentPlanId'), get(responseData, 'rate')));
};
